<template>
  <div>
    <p class="titleP">审批结果</p>
    <Card class="cardStyle">
      <Form :disabled="disabled" :label-width="85" label-position="left" class="formStyle">
       
        <Icon class="Item1" type="ios-checkmark-circle" size="65" color="#1DBF6D"></Icon>
        <br/>
        <span class="Item2">审核通过</span>
        <br/>
        <div class="Item3"><br/><span style="margin-left: 30px;">审核已提交</span><br/></div>
        <br/>
        <Button class="Item4" type="primary" @click="openApprovalPage">返回审批一览</Button>
        <br />
      </Form>  
      <Button class="Item5" @click="openHistoryApprovalPage">查看审批状况</Button>
    </Card>
    
  </div>
</template>
<script>
export default {
  props: {
    formItem: {},
    disabled: false,
  },
  data() {
    return {
      textArea: "",
    };
  },
  methods: {
    openApprovalPage(){
      this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27")
    },
    openHistoryApprovalPage(){
      this.$router.push("/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27")
    }
  },
};
</script>
<style>
.titleP{
  font-size:20px;
  color:#17233D;
  height: 40px;
  width: 100%
}
.cardStyle{
  height: 350px;
  width:1650px;
  position:relative;
}
.formStyle{
  position:absolute;
  left:48%;
  width:100%;
}
.Item1{
  margin-left:20px;
}
.Item2{
  font-size: 27px;
  color: #17233d;
  margin-top:55px
}
.Item3{
  position:absolute;
  background-color: #edfff3;
  border: 1px solid #8ce6b0;
  border-radius: 5px;
  width: 50%;
  height:60px;
  left:-22%;
  margin-top:15px;
}
.Item4{
  position:absolute;
  margin-top:90px;
}
.Item5{
  margin-top: 280px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/Component/approvalAfterPage.vue